import { render, staticRenderFns } from "./TeamActivitySkeleton.vue?vue&type=template&id=b2483c60"
import script from "./TeamActivitySkeleton.vue?vue&type=script&lang=js"
export * from "./TeamActivitySkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports